import { BlogSection } from '@/types/blog';

export const coreAndExplore: BlogSection = {
  id: 'core-and-explore',
  title: 'Core-and-Explore: Der Kompass für den denkenden Anleger',
  content: `
    <p>Die Lösung ist keine binäre Wahl, sondern eine hybride Strategie, inspiriert von Erich Fromms Unterscheidung zwischen „Haben" und „Sein":</p>

    <h3>Der Kern (Haben): 70 bis 80% des Portfolios</h3>

    <p>Kostengünstige, breit diversifizierte ETFs für effiziente Märkte (MSCI World, S&P 500). Dies ist der pragmatische Anker. Die Anerkennung der statistischen Realität. Man <strong>besitzt</strong> die Marktrendite mit minimalen Kosten.</p>

    <h3>Die Satelliten (Sein): 20 bis 30% des Portfolios</h3>

    <p>Gezielte Allokationen in aktive Manager, wo <strong>Können einen Unterschied macht</strong>:</p>
    <ul>
      <li><strong>Small Caps</strong> (Eurozone, USA): 35,9% bzw. 70% Erfolgsquote</li>
      <li><strong>Anleihen</strong> (Corporate, Duration-Management): 53,5 bis 78,7% Outperformance 2024</li>
      <li><strong>Schwellenländer</strong> (strukturelle Ineffizienzen)</li>
      <li><strong>Überzeugte aktive Manager mit hohem Active Share</strong> (über 80%) und Geduld (Cremers: plus 2,04% p.a.)</li>
    </ul>

    <p>Dies ist der „Sein"-Teil. Die bewusste Entscheidung, ein <strong>engagierter Eigentümer</strong> zu sein, nicht nur ein passiver Portfoliohalter.</p>

    <h3>Das übergreifende Prinzip: Stewardship-Due-Diligence</h3>

    <p>Selbst bei Kern-ETFs: <strong>Wie nimmt der Anbieter Eigentumsrechte wahr?</strong> Vanguard 0% ESG-Support bei Large-Caps 2023 versus State Street 60%. Das ist keine triviale Differenz. Stewardship ist kein Luxus, sondern eine <strong>treuhänderische Pflicht</strong>.</p>

    <p>Bei aktiven Satelliten: Nicht nur Performance prüfen, sondern <strong>Engagement-Qualität, Active Share, Portfolio-Turnover, Manager-Tenure</strong>. Closet Indexer (Active Share unter 60%) sofort aussortieren. Sie verlangen aktive Gebühren für passive Leistung.</p>
  `
};
